document.addEventListener('DOMContentLoaded', function(){
	//Consts
	const b = $('body'),
			intro = $('#intro'),
			isTouchDevice = () => {
				return (('ontouchstart' in window) ||
						 (navigator.maxTouchPoints > 0) ||
						 (navigator.msMaxTouchPoints > 0));
			};

    //Plugin subscriptions
  const subs_css = $('link[href*="one-subscription.css"]')
  if(subs_css.length){
    subs_css[0].disabled=true;
    $('.sohead-one-subscription-item-label-title').click(function(){
      $('.sohead-one-subscription-item-label-title').removeClass('active')
      $(this).addClass('active')
      $('#add-to-cart').prop('disabled', false).text('ADD TO CART')
    });
    if($('.sohead-one-subscription-item-label-title').length > 1){
      $('#add-to-cart').prop('disabled', true).text('SELECT AN OPTION')
    }
  }
    

	//Easing
	var speed = 400,
        speedx2 = speed*2,
		 ease = 'easeInOutQuint';

	//Functions
	function height(){
		document.documentElement.style.cssText = `
			--h:  ${window.innerHeight}px;
			--hs: ${window.innerHeight - $('header').outerHeight(true) - $('.module-newsletter').outerHeight(true) - $('footer').outerHeight(true)}px;
		`;
	}
	height()

	//Scroll Top on document ready
	// if('scrollRestoration' in history){
	// 	history.scrollRestoration = 'manual';
	// }
	// window.scrollTo(0,0);

	//Device detection
	if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent || navigator.vendor || window.opera) || isTouchDevice() == true){
		//If device
		b.addClass('mobile');
		//Pseudoclass :active on devices
		document.addEventListener('touchstart', function(){}, {passive: true});
		//Resize Functions
		window.addEventListener('orientationchange', function(){
			setTimeout(function(){
				height()
			}, 50);
		});
	}else{
		//if Desktop
		b.addClass('desktop');
		//Resize Functions
		window.onresize = function(){
			height()
		}

		//Draggable
		var p,
			 drag = $('.draggable');
		if(drag.length){
			drag.each(function(){
				var t = $(this);
				t.draggable({
					start: function(e, ui){
						p = t.scrollLeft();
					},
					drag: function(e, ui){
						t.scrollLeft(p + ui.position.left * -1);
					}
				});
			});
		}
	}

	//Replace &nbsp;
	if($('.clear').length){
		$('.clear').html(function(i, html){
			return html.replace(/&nbsp;/g, ' ');
		});
		$('.clear div:not(.exclude), .clear h2, .clear.module-empty').each(function(){
			$(this).filter(function(){
				return $(this).text().trim().length == 0;
			}).remove();
		});
	}
	if($('input.caption').length){
		$('input.caption').each(function(){
			if($(this).val().length === 0){
				$(this).parent('.exclude').remove()
			}
		});
	}

	//Loader
	var timerIntro;
	setTimeout(function(){
		$('#loader').fadeOut(200);
	}, speed);
	/*window.addEventListener('beforeunload', function (){
		$('#loader').fadeIn(200);
	});*/

	//Intro
	intro.click(function(){
		var top = intro.height();
		$('html, body').animate({
			scrollTop: top + 1
		}, speed, ease)
	})
	$(window).scroll(function(){
		if(intro.length && intro.hasClass('white') && window.innerWidth > 600){
			var top = intro.height();
			if($(window).scrollTop() > top){
				$('header').removeClass('white');
			}else{
				$('header').addClass('white');
			}
		}
	});

	// Anchors
	$('.anchor').click(function(){
		let anchor = $(this).data('anchor');
		let top = $(anchor).position().top;
		$('html, body').animate({
			scrollTop: top + 1
		}, speedx2, ease)
	});

	// Menu
	$('.trigger-menu').click(function(){
		var t = $(this),
			 n = $('.collapsed-menu[data-target="'+t.attr('id')+'"]');
		if(n.length){
			if($('.collapsed-menu').not(n).is(':visible')){
				$('.collapsed-menu:visible').slideUp('medium', 'easeInOutQuint', function(){
					$('.trigger-menu').removeClass('active')
					t.addClass('active')
					n.slideDown(speed, ease);
				});
			}else{
				t.toggleClass('active')
				n.slideToggle(speed, ease);
			}
		}
	});

	// Subsections
	$('.trigger').click(function(){
		const cta = $(this);
		const target = $(`.collapsed[data-target="${cta.attr('id')}"]`);
		if (!target.hasClass('transition')) {
			cta.toggleClass('active');
			target
				.addClass('transition')
				.slideToggle('medium', 'easeInOutQuint', () => {
					target.removeClass('transition');
				});
		}

		// if(n.length){
		// 	if($('.collapsed').not(n).is(':visible')){
		// 		$('.collapsed:visible').slideUp('medium', 'easeInOutQuint', function(){
		// 			$('.trigger').removeClass('active')
		// 			t.addClass('active')
		// 			n.slideDown(speed, ease);
		// 		});
		// 	}else{
		// 		t.toggleClass('active')
		// 		n.slideToggle(speed, ease);
		// 	}
		// }

	});

	//Filters
	// $('.filter:not(.sort)').click(function(){
	// 	var t = $(this),
	// 		 W = t.data('wrapper'),
	// 		 T = t.data('type'),
	// 		 c = t.data('class'),
	// 		 f = t.data('filter');

	// 	if(!t.hasClass('active')){

	// 		//Active/deactive filter
	// 		t.addClass('active')
	// 		 .siblings().removeClass('active');

	// 		if(f == 'all'){
	// 			if(T == 'price'){
	// 				$('.product').removeClass('active-price');
	// 			}else if(T == 'size'){
	// 				$('.product').removeClass('active-size');
	// 			}else if(T == 'category'){
	// 				$('.product').removeClass('active-category');
	// 			}else if(T == 'color'){
	// 				$('.product').removeClass('active-color');
	// 			}
	// 		}else{

	// 			//Hide projects
	// 			$('.product').addClass('active-'+T);

	// 			//Filter
	// 			$(W).removeClass().addClass(c);
	// 			var fa = $(W).attr('class'),
	// 				 ca = fa.split(/\s+/);
	// 			$.each(ca, function(index, value){
	// 				$('.product' + value).removeClass('active-'+T);
	// 			});

	// 		}

	// 	}

	// });

	//Sort
	// $('.sort').click(function(){
	// 	var t = $(this),
	// 		 k = t.data('sort');
	// 	t.siblings().removeClass('active');
	// 	if(!t.hasClass('active')){
	// 		t.addClass('active');
	// 		$('.product:not([data-'+ k +'="null"])').sort(function(a, b){
	// 			if(!t.hasClass('invert')){
	// 				return $(b).data(k) < $(a).data(k) ? 1 : -1;
	// 			}else{
	// 				return $(b).data(k) > $(a).data(k) ? 1 : -1;
	// 			}
	// 		}).prependTo('#products');
	// 	// }else{
	// 	// 	t.removeClass('active');
	// 	// 	$('.product[data-'+ k +']').sort(function(a, b){
	// 	// 		return $(b).data('pos') < $(a).data('pos') ? 1 : -1;
	// 	// 	}).prependTo('#products');
	// 	}
	// });

	//Pop-up
	const popup = $('#pop-up');
	if(popup.length){
		if(sessionStorage.getItem('pop-up') != 'true'){
			setTimeout(function(){
				popup.fadeIn()
			}, popup.data('timer')*1000);
		}else{
			popup.remove();
		}
		popup.find('span.pop-up-close').click(function(){
			popup.fadeOut(function(){
				popup.remove();
				sessionStorage.setItem('pop-up', true);
			});
		});
	}

    // Menu trigger
    $('#trigger-menu').click(function(){
      var t = $(this);
      if(!b.hasClass('transition')){
        b.addClass('transition menu-open')
        t.toggleClass('active');
        $('menu').toggle(0, function(){
          b.removeClass('transition')
          if(t.hasClass('active')){
            scrollY = $(window).scrollTop();
          }else{
            b.removeClass('menu-open')
            $(window).scrollTop(scrollY);
            $('.trigger-menu').removeClass('active');
            $('.collapsed-menu').hide();
          }
        });
      }
    });

	//Lazy Loading
	var L = [].slice.call(document.querySelectorAll('.lazy')),
		 P = [].slice.call(document.querySelectorAll('.picture > source'));
	if('IntersectionObserver' in window){
		let o = new IntersectionObserver(function(E, observer){
			E.forEach(function(e){
				if(e.isIntersecting){
					let t = e.target;
					if(t.tagName == 'IMG'){
						t.src = t.dataset.src;
						t.classList.remove('lazy');
					}
					if(t.tagName == 'VIDEO'){
						var P = t.play();
						if(P !== undefined){
							P.catch(error => {
								t.controls = true;
								t.classList.add('no-autoplay');
							});
						}
						t.classList.remove('lazy');
					}
					if(t.parentElement.tagName == 'PICTURE'){
						t.srcset = t.dataset.srcset;
						t.parentElement.classList.remove('picture');
					}
					o.unobserve(t);
				}
			});
		});
		// }, {rootMargin: '-100px 0px -100px 0px'});
		L.forEach(function(t){
			o.observe(t);
		});
		P.forEach(function(t){
			o.observe(t);
		});
	}

});
